import { container, title } from "assets/jss/material-kit-react.js";

import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const topdevPageStyle = {
  container,
  topdev: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)"
    }
  },
  cardAction:{
    textAlign:"right",
    direction:"rlt"
  },
  cardMain:{
textAlign:"left"
  },
  challengeBox:{
    marginTop:"40px",
    marginBottom:"40px"
  },
  extra:{
    display: "block",
    width: "100%",
      height: "100%",
      textAlign:"left"
  },
  media: {
    height: 140,
  },
  description: {
    margin: "1.071rem auto 0",
    textAlign: "justify !important"
  },
  name: {
    marginTop: "-80px"
  },
  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  cardHeaderTitle:{
    ...title,
    display: "inline-block",
    position: "relative",
    textDecoration: "none"
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none"
  },
  listitem:{
    fontSize:"10px"
  },
  center:{
    textAlign:"center"
  },
  box:{
    paddingBottom:"10px",
    paddingBottom:"50px",
    textAlign:"left",
    direction:"ltr"
  },
  refresh:{
    fontSize:"20px",
    position:"relative",
    top:"5px"
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999"
  },
  navWrapper: {
    margin: "20px auto 50px auto",
    textAlign: "center"
  },
  menu:{
       marginTop:"50px",
       marginBottom:"20px",
       textAlign:"left"
  },
  rightBox:{
         textAlign:"Center",
         marginBottom:"10px"
  },
  actionButton:{
    textAlign:"right",
    width:"100%",
    display:"block"
  },
  questionTile: {
    marginBottom: "25px",

  },
  questionText:{
    textAlign:"left",
    marginBottom: "25px",
    marginTop: "25px",

  },
  card:{
   marginBottom:"20px"
  },
  chips:{
    "& > *": {
      marginRight:"5px",
      marginBottom:"5px"
    }
  },
  justify:{
    textAlign:"left",
    direction:"ltr",
    textAlign:"justify"
  },
  image:{
    width:"50%",
  },
  center:{
    textAlign:"center"
  },
  rightToLeft:{
textAlign:"left",
direction:"ltr"
  },
  successButton:{
   color:"green",
  }
  
};

export default topdevPageStyle;
